import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IconCssPipe } from '../../pipes/icon-css.pipe';
import { Icon } from '../../enums/icon';

@Component({
  selector: 'app-icon',
  imports: [IconCssPipe],
  templateUrl: './icon.component.html',
  styleUrl: './icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconComponent {
  @Input({ required: true }) public icon!: Icon;
}
